import React from "react";
import { useState } from "react";
import { Image, Stack } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { AiOutlineDelete } from "react-icons/ai";
import { MdAdd, MdRemove } from "react-icons/md";
import auth from "../../init.firebase";
import {
  useAddToCartNewDataByEmailMutation,
  useDeleteCardDataByEmailIdMutation,
} from "../../redux/addToCart/addToCartApi";
import { deleteCart } from "../../redux/addToCart/addToCartSlice";

const ProductHorizontalCard = ({ cart }) => {
  const [currentQuantity, setCurrentQuantity] = useState(cart?.quantity);

  const [user] = useAuthState(auth);
  const userEmail = user?.email;

  const [deleteCardDataByEmailId, { isSuccess, isLoading, isError }] =
    useDeleteCardDataByEmailIdMutation();

  const [
    addToCartNewDataByEmail,
    { isLoading: updateLoading, isError: updateError },
  ] = useAddToCartNewDataByEmailMutation();

  const handleDelete = (id) => {
    const userEmail = user?.email;
    const productId = { productId: id };
    deleteCardDataByEmailId({ productId, userEmail });
  };

  const quantityIncrease = (quantity) => {
    let q = currentQuantity + 1;

    setCurrentQuantity(q);

    const data = {
      product: cart.product._id,
      quantity: q,
    };
    addToCartNewDataByEmail({ userEmail, data });
  };

  const quantityDecrease = (quantity) => {
    let q = currentQuantity - 1;

    setCurrentQuantity(q);

    const data = {
      product: cart.product._id,
      quantity: q,
    };
    addToCartNewDataByEmail({ userEmail, data });
  };
  console.log(cart);
  return (
    <Stack direction="horizontal" gap={3} className="pb-3 border-bottom">
      <div style={{ width: "100px" }}>
        <Image
          key={cart?.product?._id}
          src={cart?.product?.images?.[0]}
          style={{ width: "100px", height: "100px" }}
        />
      </div>
      <div className="w-100">
        <div className="d-flex align-items-start justify-content-between">
          <div style={{ fontSize: "14px", fontWeight: "bold" }}>
            {cart?.product?.name}
          </div>
          <div
            onClick={() => handleDelete(cart?.product?._id)}
            style={{
              width: "1.5rem",
            }}
            className="d-flex align-items-center justify-content-center"
          >
            <AiOutlineDelete style={{ fontSize: "1.4rem" }} />
          </div>
        </div>
        <div style={{ fontSize: "12px" }}>30ml</div>
        <div className="mt-2 d-flex align-items-center justify-content-between">
          <div
            className="d-flex align-items-center justify-content-between border"
            style={{ minWidth: "104px" }}
          >
            <button
              onClick={() => quantityDecrease(cart.quantity)}
              disabled={currentQuantity <= 1}
              style={{
                cursor: `${currentQuantity <= 1 ? "not-allowed" : "pointer"}`,
              }}
              cursor={"pointer"}
              className="px-2 py-1 d-flex align-items-center justify-content-center border-0 btn-decrease"
            >
              <MdRemove className="h6 m-0" />
            </button>
            {cart.quantity}
            <button
              onClick={() => quantityIncrease(cart.quantity)}
              cursor={"pointer"}
              className="px-2 py-1 d-flex align-items-center justify-content-center border-0 btn-increase"
            >
              <MdAdd className="h6 m-0" />
            </button>
          </div>
          <div style={{ fontSize: "15px" }}>৳ {cart?.product?.price}</div>
        </div>
      </div>
    </Stack>
  );
};

export default ProductHorizontalCard;
